module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-144x144-precomposed-13a2c63c625a79812cd67f5ac55b73ae.png";